import { Component, OnDestroy, OnInit } from '@angular/core';
import { BaseSiteService } from '@spartacus/core';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';

@Component({
    selector: 'app-reset-password-failure',
    templateUrl: './reset-password-failure.component.html',
    styleUrls: ['./reset-password-failure.component.scss'],
    standalone: false
})
export class ResetPasswordFailureComponent implements OnInit, OnDestroy {
  userAgentData: any = {};
  baseSiteId: string;
  baseSiteSub: Subscription;
  constructor(private readonly baseSite: BaseSiteService) {}

  ngOnInit(): void {
    this.baseSiteSub = this.baseSite
      .getActive()
      .pipe(take(1))
      .subscribe((res) => (this.baseSiteId = res));
    this.userAgentData = JSON.parse(localStorage.getItem('userDetails'));
    localStorage.removeItem('userDetails');
  }
  ngOnDestroy(): void {
    this.baseSiteSub?.unsubscribe();
  }
}
